import Emitter from 'src/services/emitter';
import { IMiddleware } from '../useReducerMiddleware';

export const eventEmitter = ({ id, action }: IMiddleware) => {
  if (id) Emitter.emit(id, action);
  else Emitter.emit(action.type, action.payload);
};
